export default {
    getAllProducts: () => {
        return {
            url: '/fhe/products',
            method: 'GET'
        };
    },
    getProductsByHomeId: homeId => {
        return {
            url: '/fhe/products/:homeId',
            method: 'GET',
            route_params: {
                homeId
            }
        };
    },
    getProductsDetails: (homeId, productType, productIdentifier) => {
        return {
            url: '/fhe/products/:homeId/:productType/:productIdentifier',
            method: 'GET',
            route_params: {
                homeId,
                productType,
                productIdentifier
            }
        };
    },
    updateProductField: (fieldName, homeId, identifier, type, fieldValue, moduleType) => {
        return {
            url: '/fhe/products/:homeId/:type/:identifier/:moduleType/update',
            method: 'PATCH',
            patch_params: {
                fieldName: fieldName,
                fieldValue: fieldValue,
                productType: type,
                identifier: identifier
            },
            route_params: {
                homeId,
                type,
                identifier,
                moduleType
            }
        };
    },
    dissociateProduct: (fieldName, homeId, identifier, type, fieldValue, moduleType) => {
        return {
            url: '/fhe/products/:homeId/:type/:identifier/:moduleType/dissociate',
            method: 'PATCH',
            patch_params: {
                fieldName: fieldName,
                fieldValue: fieldValue,
                productType: type,
                identifier: identifier
            },
            route_params: {
                homeId,
                type,
                identifier,
                moduleType
            }
        };
    },
    updateProductModule: (homeId, identifier, productType, code, form, type, lineType, sensorId) => {
        let patch_params = {
            code: code,
            homeId: homeId,
            identifier: identifier,
            productType: productType,
            form: form
        };
        if (sensorId) patch_params['sensorId'] = sensorId;
        return {
            url: '/fhe/products/:homeId/:type/:identifier/:type/:lineType/updateProductModule',
            method: 'PATCH',
            patch_params,
            route_params: {
                homeId,
                productType,
                identifier,
                type,
                lineType
            }
        };
    },
    deleteProduct: (homeId, productType, productIdentifier, productId) => {
        return {
            url: `/fhe/products/:homeId/:productType/:productIdentifier/:productId/deleteProduct`,
            method: 'PATCH',
            route_params: {
                homeId,
                productType,
                productIdentifier,
                productId
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Products/api.js